import React from 'react'

const QuestionsContext = React.createContext();

export default QuestionsContext;
